/* Manual appearance switch. Seasonal dates and preference expiry remain unchanged. */
(function () {
  'use strict';
  var root = document.documentElement;
  var key = root.getAttribute('data-piex-appearance-key') || 'piex:appearance:v1';
  var defaultMode = root.getAttribute('data-piex-default-mode') || 'standard';
  var selectedMode = root.getAttribute('data-piex-mode');

  function sync() {
    var active = selectedMode === 'halloween';
    document.querySelectorAll('[data-piex-theme-toggle]').forEach(function (button) {
      button.setAttribute('aria-checked', String(active));
      button.hidden = false;
    });
  }

  function change(mode, animate) {
    var transition = window.PiexModeTransition;
    if (transition) transition.cancel();
    selectedMode = mode;
    function apply() { root.setAttribute('data-piex-mode', mode); }
    if (animate && mode === 'halloween' && root.getAttribute('data-piex-mode') !== mode && transition) {
      transition.run(apply);
    } else apply();
    sync();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-piex-theme-toggle]');
    if (!button) return;
    var mode = selectedMode === 'halloween' ? 'standard' : 'halloween';
    change(mode, true);
    try { localStorage.setItem(key, mode); } catch (error) { /* The switch still works. */ }
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== key && event.key !== null) return;
    change(event.newValue === 'halloween' || event.newValue === 'standard' ? event.newValue : defaultMode, false);
  });
  document.addEventListener('shopify:section:load', sync);
  sync();
}());
